import React, { PureComponent, Fragment } from 'react'
import RefreshButton from '../../RefreshSearchButton'
import SmallInfoContainer from './SmallInfoContainer'
import SearchContent from './SearchContent'
import './styles/PostSearchFooter.css'

class PostSearchFooter extends PureComponent {
  render() {
    return (
      <Fragment>
        <SmallInfoContainer />
        <SearchContent />
        <RefreshButton cssClass="post-search" />
      </Fragment>
    )
  }
}

export default PostSearchFooter



// WEBPACK FOOTER //
// ./src/components/Elements/Footer/PostSearch/index.jsx